<script setup lang="ts">
    import Button from '@/shared/ui/Button/Button.vue';
    import { DialogClose, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/shared/ui/Dialog';
    import { useAuthDialogStore } from '../auth-dialog-store';
    import { Form } from 'vee-validate';
    import InputField from '@/shared/components/form-fields/InputField/InputField.vue';
    import PasswordField from '@/shared/components/form-fields/PasswordField/PasswordField.vue';
    import { useDialogs } from '@/shared/ui/Dialog';

    const store = useAuthDialogStore();
    const dialogs = useDialogs();
    const isLoading = ref(false);
    const { t } = useI18n();

    async function handleSubmit() {
        isLoading.value = true;
        if (await store.login()) dialogs.close({ foo: 'bar' });

        isLoading.value = false;
    }
</script>

<template>
    <Form @submit="handleSubmit">
        <DialogHeader>
            <DialogTitle>{{ $t('USER.SIGN_IN') }}</DialogTitle>
            <DialogDescription class="sr-only">{{ t('DESCRIPTION') }}</DialogDescription>
        </DialogHeader>
        <div class="my-4 space-y-4">
            <InputField
                v-model="store.loginCredentials.email"
                name="email"
                :label="$t('USER.EMAIL')"
                :placeholder="$t('USER.EMAIL')"
                rules="required|email"
            />

            <PasswordField
                v-model="store.loginCredentials.password"
                name="password"
                :label="$t('USER_ACCOUNT.PASSWORD')"
                :placeholder="$t('USER_ACCOUNT.PASSWORD')"
                rules="required"
            />
        </div>
        <DialogFooter>
            <Button
                type="button"
                variant="tertiary"
                @click="store.modalState = 'reset-password'"
            >
                {{ $t('USER.FORGOT_PASSWORD') }}
            </Button>
            <div class="flex-1" />
            <DialogClose as-child>
                <Button
                    variant="secondary"
                    type="button"
                >
                    {{ $t('GLOBAL.CANCEL') }}
                </Button>
            </DialogClose>
            <Button
                variant="brand"
                type="submit"
                :disabled="isLoading"
                :loading="isLoading"
            >
                {{ $t('USER.SIGN_IN') }}
            </Button>
        </DialogFooter>
    </Form>
</template>
<i18n lang="yaml">
en:
    DESCRIPTION: Login to your user account.
nl:
    DESCRIPTION: Log in op uw gebruikersaccount.
</i18n>
